import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  getSnapshotClient,
  OrgSnapshotSchedule,
  PutOrgSnapshotScheduleRequest
} from '@/api/snapshot-client'
import { ErrorResponse } from '@/models'

export enum SNAPSHOT_QUERY_IDS {
  GET_ORG_SNAPSHOT_SCHEDULE = 'SNAPSHOT_GET_ORG_SNAPSHOT_SCHEDULE'
}

const client = getSnapshotClient()

export const useQueryGetOrgSnapshotSchedule = (orgId: string) => {
  return useQuery<OrgSnapshotSchedule | null>({
    queryKey: [SNAPSHOT_QUERY_IDS.GET_ORG_SNAPSHOT_SCHEDULE, orgId],
    queryFn: () => client.getOrgSnapshotSchedule(orgId),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false
  })
}

export const useMutationPutOrgSnapshotSchedule = (orgId: string) => {
  const queryClient = useQueryClient()

  return useMutation<
    OrgSnapshotSchedule,
    ErrorResponse,
    PutOrgSnapshotScheduleRequest,
    unknown
  >({
    mutationFn: (body: PutOrgSnapshotScheduleRequest) =>
      client.putOrgSnapshotSchedule(orgId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SNAPSHOT_QUERY_IDS.GET_ORG_SNAPSHOT_SCHEDULE, orgId]
      })
    }
  })
}
